import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-5" id="blog">
      <Container className="main-sec">
        <Row>
          <Col sm={12} className="bg-white p-4 shadow mb-3 text-center">
            <img src="/graphics/images/404.webp" alt="404 Not Found" width="300px" className="mb-3" />
            <br />
            <Button variant="dark" size="lg" onClick={() => navigate('/')}>
              <i className="fas fa-home"></i> Go To Home
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotFound;
